export const getErrMsg = (errors: Record<string, unknown>[], field: string) => {
  // @ts-ignore
  return errors[field]?.message;
};
